import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const deleteArticle = {
  name: "deleteArticle" as const,
  input: z.object({ id: z.string() }),
  output: zExt.coercedResult(z.object({})),
};
